import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { BoxProps } from '@mui/material';
import StyAdornedInput from './StyAdornedInput';

type Props = { optionsLeft: string[] };

const StyNumberLeft = styled(StyAdornedInput, {
    name: 'StyNumberLeft',
})<BoxProps>(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.primary.main,
    borderRadius: '1rem',
}));

const StyLabelNumber = styled('span', {
    name: 'StyLabelNumber',
})({
    overflow: 'hidden',
    width: 'fit-content',
    fontSize: '0.85rem',
    maxWidth: 'inherit',
});

export default function NumberLeft(props: Props): React.ReactElement {
    return (
        <StyNumberLeft tabIndex={-1}>
            <Tooltip
                title={props.optionsLeft.join(', ')}
                placement="bottom-start"
                enterDelay={50}
            >
                <StyLabelNumber> +{props.optionsLeft.length}</StyLabelNumber>
            </Tooltip>
        </StyNumberLeft>
    );
}
